
export const aggregateByField = (kvList)=> {
    let mapping = {};
    kvList.forEach(pair => {
        let [wgt, field] = pair;
        if (!mapping.hasOwnProperty(field)) {
            mapping[field] = {
                count: 0,
                wgt: 0
            };
        }
        mapping[field].wgt += wgt;
        mapping[field].count += 1;
    });
    return mapping;
}


const reformatSet = (set) => {
    return set.map((x)=>{
        return [x.wgt, x?.sector ?? 'missing'];
    })
}


/**
 * Prepare data for the grouped bar chart
 * @param localSubset
 * @param consolidatedList
 * @param displayField
 * @returns {*[]}
 */
export const prepareGroupedBarData = (localSubset, consolidatedList, displayField) => {
    let subsetMap = aggregateByField(reformatSet(localSubset), displayField);
    let fullsetMap = aggregateByField(reformatSet(consolidatedList), displayField);

    let data = [];
    for (let sector in fullsetMap) {
        let mult = displayField === 'wgt' ? 100 : 1; // Multiply by 100 if we're dealing with weights
        data.push({
            id: sector,
            'Full Set': fullsetMap[sector][displayField] * mult,
            'Subset': subsetMap[sector]?.[displayField] * mult ?? 0
        })
    }
    data.sort((a, b) => a['Full Set'] - b['Full Set']);
    return data;
};



export const formatPreviewDetails = (localSubset, consolidatedList, weightOption)=>{
    return [
        {k: "Tickers Kept in Subset", v: localSubset.length, primary: true},
        {k: 'Tickers Removed', v: consolidatedList.length - localSubset.length, danger: true},
        {k: 'Weight Option', v: weightOption},
    ];
}


/**
 * Aggregate market caps for the subset and the full set
 * @param consolidatedList
 * @param subset
 * @returns {{totalMarketCap: number, subsetMarketCap: number}}
 */
export const aggregateMarketCaps = (consolidatedList, subset) => {
    const subsetTickers = subset.map(item => item.symbol);
    let totalMarketCap = 0;
    let subsetMarketCap = 0;
    consolidatedList.forEach(item => {
        if (subsetTickers.includes(item.symbol)) {
            subsetMarketCap += item.mktcap;
        }
        totalMarketCap += item.mktcap;
    });
    return { subsetMarketCap, totalMarketCap };
}



export const aggregatePriceStats = (consolidatedList, subset) => {
    const subsetTickers = subset.map(item => item.symbol);
    let maxPrice = 0;
    let avgPrice = 0;
    let maxPriceWeight = 0;
    consolidatedList.forEach(item => {
        if (subsetTickers.includes(item.symbol)) {
            maxPrice = Math.max(maxPrice, item.px);
            maxPriceWeight = Math.max(maxPriceWeight, item.wgt);
            avgPrice += item.px;

        }
    });
    avgPrice /= subset.length;
    return { maxPrice, avgPrice, maxPriceWeight };
}